import template from './currency.edit.html';
import controller from './currency.edit.controller';
import './currency.edit.scss';

let currencyeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default currencyeditComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/edit/currency.edit.component.js